export default function About() {
  const stats = [
    { value: '256+', label: 'Bit Encryption' },
    { value: '50+', label: 'Global Servers' },
    { value: '99.9%', label: 'Uptime Guarantee' },
    { value: '24/7', label: 'Customer Support' }
  ];

  return (
    <section id="about" className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-4">
          <p className="text-sm text-gray-600 font-medium">About POLONYI S.R.L.</p>
        </div>

        <div className="max-w-4xl mb-16">
          <p className="text-3xl text-gray-900 leading-relaxed font-light">
            At POLONYI S.R.L., we are committed to protecting your digital privacy and security. Our mission is to provide cutting-edge VPN technology that empowers users to browse the internet freely and securely. With years of expertise in cybersecurity, we deliver innovative solutions that prioritize user protection and data privacy above all else.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-24 gap-y-16 max-w-4xl">
          {stats.map((stat, index) => (
            <div key={index}>
              <div className="text-6xl font-bold text-gray-900 mb-3">
                {stat.value}
              </div>
              <div className="text-base text-gray-500 font-light">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
